import React, { createContext, useContext, useEffect, useState } from "react";
import { api } from "../lib/api";

const AuthContext = createContext(null);

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const token = localStorage.getItem("mdp_token");
    if (!token) {
      setLoading(false);
      return;
    }
    api
      .get("/auth/me")
      .then((r) => setUser(r.data))
      .catch(() => localStorage.removeItem("mdp_token"))
      .finally(() => setLoading(false));
  }, []);

  const login = async (email, password) => {
    const { data } = await api.post("/auth/login", { email, password });
    localStorage.setItem("mdp_token", data.token);
    setUser({ email: data.email, role: data.role, name: data.name || "" });
    return data;
  };

  const register = async (name, email, password) => {
    const { data } = await api.post("/customers/register", { name, email, password });
    localStorage.setItem("mdp_token", data.token);
    setUser({ email: data.email, role: data.role, name: data.name });
    return data;
  };

  const logout = () => {
    localStorage.removeItem("mdp_token");
    setUser(null);
  };

  return <AuthContext.Provider value={{ user, loading, login, register, logout }}>{children}</AuthContext.Provider>;
};

export const useAuth = () => useContext(AuthContext);
